import React from "react";

import { AppConfigurationUrlQueryParams } from "../../url";
import AppConfigurationListPage from "./AppConfigurationListPage";

export interface AppConfigurationProps {
  params: AppConfigurationUrlQueryParams;
}

export const AppConfiguration: React.FC<AppConfigurationProps> = ({
  params
}) => (
  <>
    <AppConfigurationListPage params={params} />
  </>
);
export default AppConfiguration;
